import * as Yup from 'yup';

const ManualWithdrawSchema = Yup.object().shape({
    date: Yup.lazy((val) =>
        Array.isArray(val)
            ? Yup.array().of(Yup.string()).required('فیلد مبلغ الزامی است')
            : Yup.string().required('فیلد مبلغ الزامی است'),
    ),
    bank_account: Yup.string().required('فیلد حساب بانکی الزامی است'),
});

export default ManualWithdrawSchema;
